import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from '../../../components';
import useLoginModal from '../../login/useLoginModal';
import { analyticEventLogger } from '../../../utils/commonUtils';
import { SELLER_TICKET_MYLISTING_EVENT_CLICK } from '../../../constants/eventLogger';


const EmptyListing = () => {
  const navigate = useNavigate();
  const loginModal = useLoginModal();

  const { userData } = useSelector((state) => state.app);

  const handleSellClick = () => {
    analyticEventLogger(SELLER_TICKET_MYLISTING_EVENT_CLICK, {});
    if (!userData?.email) {
      loginModal.onOpen();
      loginModal.callback.current = () => navigate('/sell-tickets');
    } else navigate('/sell-tickets');
  };
  return (
    <div className='flex gap-20 border rounded-xl border-grey-10  w-auto md:w-[630px]'>
      <div className='flex flex-col gap-6 pl-9 py-8'> 
        <div className='flex flex-col gap-3'> 
          <div className='heading-16'>No active listings!</div>
          <div className='text-14'>List your spare tickets now and make a fan's day! 🤙</div>
        </div>
        <Button
          type='primary'
          onClick={handleSellClick}>Sell tickets</Button>
      </div>
      <img
        src='assets/images/nolist.png'
        alt='no list'
        className='rounded-r-lg md:block hidden'
      />
      
    </div>
  )
}

export default EmptyListing;